@if (isAuthorized) {
  <div class="jobStarterContainer">
    <!--Schnellstartknöpfe -->
    @for (job of availableJobs; track job) {
      @if (job.quickstarterIcon) {
        <button
          [hisImage]="job.quickstarterIcon"         
          [title]="job.name"
          (click)="startJob(job)">
        </button>
      }
    }
    <!-- Jobauswahl -->
    <button class="jobstartBadge"
            (click)="showJobListDialog = true">{{'cs.sys.reporting.oo.chooseJob' | hisUi}}</button>
    
    <p-dialog [(visible)]="showJobListDialog" styleClass="jobstarterPngOverlay" [modal]="true" [dismissableMask]="true" [blockScroll]="true" appendTo="body" [header]="'cs.sys.reporting.oo.chooseJob' | hisUi">
      <dl class="definitionListGrid jobstarterPNG">
        @for (job of availableJobs; track job) {
          <dt>
            <a href="#" 
               (click)="$event.stopPropagation(); $event.preventDefault(); startJob(job); showJobListDialog = false; jobListSelection=null;"
               (keydown.space)="$event.stopPropagation(); $event.preventDefault(); startJob(job); showJobListDialog = false; jobListSelection=null;">{{job.name}}</a>
          </dt>
          <dd>
            <button
              type="button"
              class="plamButton icon"
              hisImage="PENCIL"
              [title]="'cs.sys.reporting.job.showJobConfiguration' | hisUi"
              [attr.aria-label]="'cs.sys.reporting.job.showJobConfiguration' | hisUi"
              (click)="$event.stopPropagation(); showJobConfigForJob(job); showJobListDialog = false;">
            </button>
          </dd>
        }
      </dl>
      <button type="button" (click)="showJobListDialog=false">{{'common.close' | hisUi}}</button>
    </p-dialog>
    <!-- Job Configuration Panel-->
    <his-job-configuration
      [settings]="selectedJob?.defaultJobSettings"
      (startJobClicked)="startJob()">
    </his-job-configuration>
    <!-- Fortschrittsanzeige -->
    @if (lastStartedJob && !lastStartedJob.finishedAt) {
      <span class="jobStarterSpinner progressSpinnerContainer">
        @if (lastStartedJob && !lastStartedJob.finishedAt) {
          <p-progressSpinner
            strokeWidth="8"
            fill="#EEEEEE"
            animationDuration="5s">
          </p-progressSpinner>
        }
      </span>
    }
    <!-- Job-Protokoll -->
    @if (lastStartedJob) {
      <his-job-details
        [jobStatus]="lastStartedJob">
      </his-job-details>
    }
    <!-- Entwicklerausgaben -->
    @if (debugAvailable) {
      <button
        hisImage="debug"
        class="plamButton icon"
        [title]="'Debuginfos'"
        (click)="toggleShowDebug()">
      </button>
    }
    <p-dialog
      appendTo="body"
      [(visible)]="showDebug"
      [modal]="true" [dismissableMask]="true" [blockScroll]="true"
      [header]="'common.components.jobConfigurationPanel.lastExecutionProtocol.title' | hisUi">
      <!-- ngIf required to avoid ExpressionChangedAfterItHasBeenCheckedError in devMode caused by json pipe, see #255698 -->
      <div class="plamRow">
        <pre>Job-Starter: '{{key}}'</pre>
        @if (!selectedJob) {
          <pre>selectedJob: none</pre>
        }
        @if (selectedJob) {
          <pre>selectedJob: {{selectedJob | json}}</pre>
        }
        @if (!lastStartedJob) {
          <pre>lastStartedJob: none</pre>
        }
        @if (lastStartedJob) {
          <pre>lastStartedJob: {{lastStartedJob | json}}</pre>
        }
        @if (!lastError) {
          <pre>lastError: none</pre>
        }
        @if (lastError) {
          <pre>lastError: {{lastError | json}}</pre>
        }
      </div>
    </p-dialog>
  </div>
}
